import { CommentsoldIntegrationProduct } from "@redotech/redo-model/commentsold";
import * as z from "zod/v4";

export const createCommentsoldIntegration = {
  name: "createCommentsoldIntegration" as const,
  input: z.object({
    product: z.enum(CommentsoldIntegrationProduct),
    shop: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
